import { CardBody, CardHeader, Toast } from "reactstrap";

import Breadcrumbs from "@src/@core/components/ui-components/breadcrumbs";
import Card from "@src/@core/components/ui-components/card";
import CopyToClipboard from "@src/@core/components/ui-components/copy-to-clipboard";
import CustomAlerts from "@src/@core/components/ui-components/alerts";
import Flex from "@src/@core/components/ui-components/flex";
import InputPasswordToggle from "@src/@core/components/fields/input-password-toggle";
import { LoaderOverlay } from "@src/@core/components/spinner";
import LoadingButton from "@components/ui-components/loading-button";
import React from "react";
import useApiKey from "./use-apikey";
import { useTranslation } from "react-i18next";

const ApiKey = () => {
    const {
        data: { apikey },
        loading,
        regenerateApiKey
    } = useApiKey();
    const { t } = useTranslation();

    const handleRegenerateKey = async () => {
        if (
            Toast(
                "Are you sure you want to regenerate your API key? This will revoke your current key."
            )
        ) {
            await regenerateApiKey();
        }
    };

    return (
        <>
            <Breadcrumbs
                items={[
                    {
                        title : "API Key",
                        active: true
                    }
                ]}/>
            <LoaderOverlay
                active={loading}
                children={
                    <Card>
                        <CardHeader>
                            <small className="text-muted">
                                {t(
                                    "Use this API key to authenticate your requests to our API"
                                )}
                            </small>
                        </CardHeader>
                        <CustomAlerts
                            color="warning"
                            body={
                                "Important: Keep your API key secure and don't share it publicly. Regenerating will revoke your current key immediately."
                            }
                            className="mt-2"
                            testId="api-key-warning"/>
                        <CardBody>
                            {apikey?.key ? (
                                <div>
                                    <Flex justify="between">
                                        <Flex align="center" className="mb-2 w-75">
                                            <InputPasswordToggle
                                                name="apikey"
                                                value={apikey.key}
                                                readOnly
                                                htmlFor="apikey-input"
                                                placeholder={t("API Key")}/>
                                            <CopyToClipboard
                                                text={apikey.key}
                                                tooltipContent={
                                                    "Copy to clipboard"
                                                }
                                                id="copy-apikey"
                                                testId="copy-apikey-btn"/>
                                        </Flex>

                                        <LoadingButton
                                            color="primary"
                                            text={"Regenerate Key"}
                                            icon="refresh"
                                            onClick={handleRegenerateKey}
                                            testId="regenerate-key-btn"/>
                                    </Flex>
                                </div>
                            ) : (
                                <div className="text-center py-4">
                                    <p className="text-muted mb-2">
                                        {t("No API key found")}
                                    </p>
                                    <LoadingButton
                                        color="primary"
                                        text={"Generate API Key"}
                                        onClick={regenerateApiKey}
                                        testId="generate-key-btn"/>
                                </div>
                            )}
                        </CardBody>
                    </Card>
                }/>
        </>
    );
};

export default ApiKey;
